<button
  class="pinned-message__button"
  type="button"
  cdkOverlayOrigin
  #triggerShowPinnedMessage="cdkOverlayOrigin"
  (click)="setShowPinnedMessage('toggle')"
  [class.active]="isShowPinnedMessage()"
>
  <svg-icon
    class="flex items-center justify-center s-14"
    src="assets/icons/shared/info.svg"
  ></svg-icon>
</button>
<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="triggerShowPinnedMessage"
  [cdkConnectedOverlayOpen]="isShowPinnedMessage()"
  (detach)="setShowPinnedMessage('hide')"
>
  <div class="pinned-message" (clickOutside)="setShowPinnedMessage('hide')">
    <button
      (click)="setShowPinnedMessage('hide')"
      class="pinned-message__button-close"
    >
      <svg-icon
        class="flex items-center justify-center s-16"
        src="assets/icons/ui/cross.svg"
      />
    </button>

    <p class="pinned-message__message">
      {{ pinnedMessageService.pinnedMessage()?.message }}
    </p>

    <div class="pinned-message__bottom">
      @if (!pinnedMessageService.isAlwaysHidePinnedMessage()) {
      <button
        (click)="
          setShowPinnedMessage('hide');
          pinnedMessageService.alwaysHidePinnedMessage()
        "
        class="pinned-message__button-always"
      >
        don't show always
      </button>
      }
      <button
        (click)="setShowPinnedMessage('hide')"
        class="pinned-message__button-hide"
      >
        hide
      </button>
    </div>
    @if (isShowCountdown()) {
    <app-level-bar
      animate.enter="animate-fade-in"
      class="pinned-message__timer"
      [current]="countDownCurrent()"
      [total]="100"
    />
    }
  </div>
</ng-template>
